import React from "react";

const TermsOfUse = () => {
  return (
    <div className="bg-white text-gray-900 p-8 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-blue-700">Terms of Use for OP Game Tracker</h1>
      <p className="mb-4 text-sm">Effective Date: May 2, 2025</p>

      <p className="mb-4">
        Welcome to <strong>OP Game Tracker</strong> (“we,” “our,” “us,” or the “Site”). These Terms of Use (“Terms”)
        govern your use of our website and services at{" "}
        <a href="https://opgametracker.com" className="text-blue-600 underline">
          opgametracker.com
        </a>. By using our Site, you agree to these Terms.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">1. Use of the Site</h2>
      <p className="mb-2">You agree to use OP Game Tracker only for lawful purposes. You must not:</p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Violate any applicable laws or regulations.</li>
        <li>Attempt to disrupt the Site's integrity or security.</li>
        <li>Use automated tools (e.g., bots, scrapers) without permission.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">2. User Accounts</h2>
      <p className="mb-4">
        If account features are available, you are responsible for safeguarding your login credentials and keeping your
        information accurate. We may suspend or terminate accounts at our discretion.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">3. Content and Data</h2>
      <p className="mb-4">
        Our game information is sourced via third-party APIs such as IGDB. All trademarks, logos, and game content
        belong to their respective owners. You may not reproduce or redistribute this content without permission.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">4. Third-Party Links and Content</h2>
      <p className="mb-4">
        We may link to or embed third-party services like YouTube. We are not responsible for the practices or policies
        of external websites.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">5. Advertising and Google AdSense</h2>
      <p className="mb-4">
        This website uses Google AdSense to display advertisements. By using this site, you acknowledge that:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Google AdSense may use cookies and similar technologies to display personalized ads</li>
        <li>Third-party vendors, including Google, may use cookies to serve ads based on your visits to this and other websites</li>
        <li>You can opt out of personalized advertising by visiting Google Ads Settings</li>
        <li>We are not responsible for the content or practices of third-party advertisers</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">6. Disclaimers</h2>
      <p className="mb-4">
        OP Game Tracker is provided "as is" and "as available". We make no guarantees about the accuracy or
        availability of content or data.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">7. Limitation of Liability</h2>
      <p className="mb-4">
        We are not liable for any damages arising from your use or inability to use the Site, including loss of data or
        indirect damages.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">8. Modifications</h2>
      <p className="mb-4">
        We may update these Terms at any time. Changes will be posted on this page with the updated effective date.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">9. Contact Us</h2>
      <p className="mb-2">
        If you have any questions about these Terms, you can contact us at:
      </p>
      <p className="mb-2">
        Email:{" "}
        <a href="mailto:contact@opgametracker.com" className="text-blue-400 hover:underline">
          contact@opgametracker.com
        </a>
      </p>
      <p>
        Website:{" "}
        <a href="https://opgametracker.com" className="text-blue-600 underline">
          https://opgametracker.com
        </a>
      </p>
    </div>
  );
};

export default TermsOfUse;
